<template>
  <f7-page
    :page-content="true"
  >
    <f7-navbar>
      <f7-nav-title class="text-madai">Gracias por tu compra</f7-nav-title>
    </f7-navbar>

    <img class="wd-100" src="assets/img/banners/gracias.jpg" alt="">

    <f7-card class="m-t-0">
      <f7-card-header class="no-border">
        <div class="margin-auto bold text-madai">
          <!-- <img src="@/assets/img/logo_250.png" width="50" height="50"/> -->
          Todos los detalles de la compra se han enviado a tu correo electrónico.
        </div>
      </f7-card-header>
      <f7-card-content :padding="false">
        <f7-list>
          <f7-list-item
            header="Número de transacción"
            :title="detalle.id"
          >
          </f7-list-item>
          <f7-list-item
            header="Fecha de transacción"
            :title="moment(detalle.create_time).format('LL')"
          >
          </f7-list-item>
          <f7-list-item>
            <div class="margin-auto bold">Listado de artículos</div>
          </f7-list-item>
          <f7-list-item v-for="(itm, idx) in detalle.transactions[0].item_list.items" v-bind:key="idx"
            :title="itm.description"
            :header="itm.name"
            :after="$helper.str.formatearMoneda(itm.price)"
          >
          </f7-list-item>
        </f7-list>
      </f7-card-content>
      <f7-card-footer>
        <div class="left">Total</div>
        <div class="right bold">
          {{ $helper.str.formatearMoneda(detalle.transactions[0].amount.total) }}
        </div>
      </f7-card-footer>
    </f7-card>

    <f7-block>
      <div class="bold text-center fs-12">
        2019 Madai. Todos los derechos reservados.
      </div>
    </f7-block>
  </f7-page>
</template>

<script>
import * as moment from 'moment'

moment.locale('es')

export default {
  methods: {
    moment: moment
  },
  data () {
    return {
      detalle: ''
    }
  },
  created () {
    this.detalle = this.storage.transaccion
    this.detalle.payer.payer_info.name = this.detalle.payer.payer_info.first_name + ' ' + this.detalle.payer.payer_info.last_name
    this.storage.transaccion = {
      id: '',
      intent: 'sale',
      state: '', // approved, declined
      cart: '',
      create_time: '',
      promos: [],
      payer: {
        payment_method: '',
        status: '-',
        payer_info: {
          email: '',
          first_name: '',
          middle_name: '',
          last_name: '',
          payer_id: '-',
          country_code: 'MX',
          shipping_address: {
            recipient_name: '',
            line1: '',
            city: '',
            state: '',
            postal_code: '',
            country_code: 'MX',
            suburb: ''
          },
          phone: '',
          name: ''
        }
      },
      transactions: [
        {
          amount: {
            total: '',
            currency: '',
            details: {}
          },
          item_list: {
            items: []
          },
          related_resources: []
        }
      ]
    }
    this.storage.cupon = {
      codigo: '',
      porcentaje: 0,
      valido: false
    }
    this.storage.carrito = []
  }
}
</script>
